// extracted by mini-css-extract-plugin
export var callCard = "_r3-0";
export var callMessageButton = "_r3-1";
export var helpIcon = "_r3-3";
export var helpIconContainer = "_r3-4";
export var verticalDivider = "_r3-2";